import TheGrid from '@/views/dealers/operators_excluded/grid'
import Edit from '@/views/dealers/operators_excluded/edit'

export default {
  path: '/dealers/operators_excluded',
  redirect: '/dealers/operators_excluded/index',
  name: 'operators_excluded',
  meta: {
    auth: {
      redirect: {
        name: 'operators_excluded.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'DSR'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'operators_excluded.index',
    component: TheGrid,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Lista'
    }
  }, {
    path: 'create',
    name: 'operators_excluded.create',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Criar'
    }
  }, {
    path: 'edit/:id',
    name: 'operators_excluded.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
  }]
}
